import type { SiteConfig } from '../shared/site-config'

// Vite embeds the selected public configuration at build time; never put secrets here.
declare const __SITE_CONFIG__: SiteConfig
export const siteConfig = __SITE_CONFIG__
